import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/create-store';
import { SetsData, SetsState } from 'store/sets/types';

export const getSetsState = (state: RootState): SetsState => state.sets;

export const getSetsData = createSelector([getSetsState], (state: SetsState): SetsData => {
  if (!state?.data) return state?.data;

  return {
    ...state.data,
    fundraising_goal: (parseInt(state.data?.fundraising_goal) / 100).toString(),
    fundraising_raised: (parseInt(state.data?.fundraising_raised) / 100).toString(),
    set_pages: state.data?.set_pages?.map(page => ({
      ...page,
      page_fundraising_goal: (parseInt(page.page_fundraising_goal) / 100).toString(),
      page_fundraising_raised: (parseInt(page.page_fundraising_raised) / 100).toString(),
    })),
    pages: state.data?.pages?.map(page => ({
      ...page,
      raised: (
        parseInt(
          state.data?.set_pages?.find(set => set.page_id === page.id)?.page_fundraising_raised ||
            '0'
        ) / 100
      ).toString(),
      fundraising_goal: (parseInt(page.fundraising_goal) / 100).toString(),
    })),
  };
});

export const getSetsStateAndData = createSelector(
  [getSetsState, getSetsData],
  (setsState, setsData) => ({ setsState, setsData })
);
